import { Component, Input, OnChanges, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { LoadingService } from '../../../../services/loading.service';
import { LoginService } from '../../../../services/login.service';
import { Appropriator, AppropriatorsService } from '../../../../services/appropriators.service';
import { Pod, PodsService } from '../../../../services/pods.service';
import { SponsorContact, SponsorContactService } from '../../../../services/sponsor-contact.service';
import { PodSponsorModalComponent } from '../pod-sponsor-modal/pod-sponsor-modal.component';
import { ConfirmationModalComponent } from '../confirmation-modal/confirmation-modal.component';

@Component({
  selector: 'app-pod-sponsors',
  templateUrl: './pod-sponsors.component.html',
  styleUrls: ['./pod-sponsors.component.scss']
})
export class PodSponsorsComponent implements OnInit, OnChanges, OnDestroy {

  @Input() appropriator: Appropriator;
  @Input() pod: Pod;

  podSponsors: SponsorContact[];
  selectedSponsor: SponsorContact;

  authenticated: Observable<boolean>;

  //sponsorForm: FormGroup = null;
  //sponsorFormTitle: string;
  //sponsorModalFailure: string;

  //activeModal: NgbModalRef;

  unsubscribe: Subject<any> = new Subject;

  @ViewChild('sponsorModal', { static: false }) sponsorModal: PodSponsorModalComponent;
  @ViewChild('deleteConfirmation', { static: false }) deleteConfirmation: ConfirmationModalComponent;

  constructor(
    private loadingService: LoadingService,
    private loginService: LoginService,
    private sponsorContactsService: SponsorContactService
  ) {
    this.authenticated = loginService.authenticated;
    //this.sponsorForm = new FormGroup({
    //  sponsorContactId: new FormControl(null, []),
    //  sponsorName: new FormControl(null, []),
    //  sponsorEmail: new FormControl(null, [
    //    Validators.required,
    //    Validators.email
    //  ])
    //});
  }

  ngOnInit() {
    this.sponsorContactsService.currentSponsorContacts
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(response => {
        if (!!response) {
          this.podSponsors = response;
        }
      });
  }

  ngOnChanges() {
    if (!!this.pod && !!this.pod.permitPointOfDiversionId)
      this.sponsorContactsService.getSponsorContacts(this.pod.permitPointOfDiversionId);
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  openAddSponsorModal() {
    this.sponsorModal.modalTitle = "Add New Sponsor Contact";
    this.openModal();
  }

  openEditSponsorModal(sponsorContact: SponsorContact) {
    this.selectedSponsor = sponsorContact;
    this.sponsorModal.modalTitle = "Edit Sponsor Contact";
    this.sponsorModal.setFormValues(sponsorContact.sponsorContactId, sponsorContact.name, sponsorContact.email);
    this.openModal();
  }

  openModal() {
    this.sponsorModal.podId = this.pod.permitPointOfDiversionId;
    this.sponsorModal.open().then(
      () => this.ngOnChanges()
    ).catch(
      (error) => console.warn(`Modal dismissed: ${error}`)
    );
  //  this.activeModal = this.modalService.open(content);
  //  this.activeModal.result
  //    .then(
  //      () => this.ngOnChanges()
  //    ).catch(
  //      (error) => console.warn("Modal dismissed: {{error}}")
  //    );
  //  this.sponsorModalFailure = null;
  }

  openDeleteConfirmationModal(sponsorContact: SponsorContact) {
    this.selectedSponsor = sponsorContact;
    this.deleteConfirmation.open().then(
      () => {
        this.deleteSponsor(sponsorContact);
        setTimeout(() => this.ngOnChanges(), 1000);
      }
    ).catch(
      (error) => console.warn(`Modal dismissed: ${error}`)
    )
  }

  deleteSponsor(sponsorContact: SponsorContact) {
    this.sponsorContactsService.deleteSponsorContact(sponsorContact.sponsorContactId);
  }

  //modalHasErrors() {
  //  return false;
  //}

  //sponsorFormId() {
  //  return this.sponsorForm.get('sponsorContactId');
  //}

  //sponsorFormName() {
  //  return this.sponsorForm.get('sponsorName');
  //}

  //sponsorFormEmail() {
  //  return this.sponsorForm.get('sponsorEmail');
  //}

  //clearSponsorForm() {
  //  this.sponsorForm.reset();
  //}

}
